import React from "react";
import imageSrc from "../images/newLogo.jpg"
import { useNavigate } from "react-router-dom";

const NotAuthorized = () => {
  const navigate = useNavigate()
  return (
    <main className="h-screen overflow-hidden">
      <div className="px-4 py-3">
        <img src={imageSrc} alt="ICICI Life Insurance" className="w-24 lg:w-32 w-auto rounded-lg object-contain" />
      </div>

      <div className="flex flex-col h-full items-center justify-center">
        <h1 className="text-4xl font-bold text-red-500">403 - Access Denied</h1>
        <p className="text-lg mt-3">You do not have permission to view this page.</p>
        <button onClick={() => navigate("/login")} className=" mt-2 border focus:border-blue-600 flex items-center border-[#E0E0E0] rounded py-1.5 px-3">Navigate to Login </button>

      </div>
    </main>
  );
};

export default NotAuthorized;
